import React, { useState } from 'react';
import Matriz from './Matriz';

const Table = (props) => {
  const [hovered, setHovered] = useState({ row: null, col: null });

  if (props.matriz.rows.length === 0) {
    return (
      <div className="hidden md:block">
        <div className="rounded-xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500">
          No hay módulos o acciones configuradas.
        </div>
      </div>
    );
  }

  const gridTemplateColumns = `220px repeat(${props.matriz.actions.length}, minmax(0, 1fr))`;

  return (
    <div className="hidden md:block">
      <div className="rounded-xl border border-gray-300 bg-white" style={{ overflow: 'clip' }}>

        {/* Scroll de página: el título de la matriz y la cabecera de acciones quedan fijos con
            un pequeño espacio arriba (sticky top-3, bajo la capa de fondo) al llegar arriba,
            mientras el título "Permisos" + selector de roles se desplazan con el scroll. */}
        <div className="sticky top-3 z-20">
          <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 bg-white">
            <div>
              <h2 className="text-sm font-semibold text-gray-800">Matriz de permisos</h2>
              <p className="text-xs text-gray-500">Configura accesos por módulo y acción</p>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <span>{props.matriz.rows.length} módulos</span>
              <span>•</span>
              <span>{props.matriz.actions.length} acciones</span>
            </div>
          </div>

          <div className="grid w-full border-b border-gray-200 bg-gray-50" style={{ gridTemplateColumns }}>
            <div className="sticky left-0 z-30 border-r border-gray-200 bg-gray-50 px-4 py-3 text-left text-sm font-semibold">
              Permisos
            </div>
            {props.matriz.actions.map((action) => (
              <div
                key={action.Id}
                className="flex items-center justify-center border-r border-gray-200 bg-gray-50 text-center text-sm font-semibold"
              >
                {action.Name}
              </div>
            ))}
          </div>
        </div>

        {/* Body del grid: scrollea con la página */}
        <div className="grid w-full" style={{ gridTemplateColumns }}>
          {props.matriz.rows.map((row) => {
            const isRow = hovered.row === row.Id;
            return (
              <React.Fragment key={row.Id}>
                <div
                  className={`sticky left-0 z-10 flex items-center border-b border-r border-gray-200 px-4 py-3 text-sm font-medium transition
                    ${isRow ? 'bg-gray-100' : 'bg-white'}`}
                >
                  {row.Name}
                </div>
                <Matriz
                  row={row}
                  hovered={hovered}
                  setHovered={setHovered}
                  permissions={props.permissions}
                  isEditor={props.isEditor}
                  permissionsRoles={props.permissionsRoles}
                  setPermissionsSave={props.setPermissionsSave}
                />
              </React.Fragment>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default Table;
